module.exports = __webpack_public_path__ + "static/media/customer.a0fb2970.svg";